import {
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  updatePassword,
  EmailAuthProvider,
  reauthenticateWithCredential,
  onAuthStateChanged,
  type User,
} from 'firebase/auth';
import { auth } from '@/lib/firebase';
import { logEvent } from './audit.service';

export const authService = {
  async signIn(email: string, password: string): Promise<User> {
    const credential = await signInWithEmailAndPassword(auth, email, password);
    await logEvent({
      entityType: 'user',
      entityId: credential.user.uid,
      action: 'login',
      tenantId: null,
      performedBy: credential.user.uid,
      performedByEmail: email,
    });
    return credential.user;
  },

  async signOut(): Promise<void> {
    const user = auth.currentUser;
    if (user) {
      await logEvent({
        entityType: 'user',
        entityId: user.uid,
        action: 'logout',
        tenantId: null,
        performedBy: user.uid,
      });
    }
    await signOut(auth);
  },

  async sendPasswordReset(email: string): Promise<void> {
    await sendPasswordResetEmail(auth, email);
  },

  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    const user = auth.currentUser;
    if (!user || !user.email) throw new Error('No authenticated user');
    const credential = EmailAuthProvider.credential(user.email, currentPassword);
    await reauthenticateWithCredential(user, credential);
    await updatePassword(user, newPassword);
  },

  onAuthStateChanged(callback: (user: User | null) => void) {
    return onAuthStateChanged(auth, callback);
  },

  getCurrentUser(): User | null {
    return auth.currentUser;
  },
};
